/* eslint-disable react-hooks/exhaustive-deps */
import { useHeroApiService } from '@core/hooks';
import { StudioPhoto } from '@core/models';
import { useEffect, useState } from 'react';

const SocialPostImage = ({ locationId, mediaId }: { locationId: string; mediaId: string }) => {
  const heroApiService = useHeroApiService();
  const [studioPhoto, setStudioPhoto] = useState<StudioPhoto | null>(null);
  useEffect(() => {
    const init = async () => {
      const _studioPhoto = await heroApiService.getStudioPhotoByMediaId(locationId, mediaId);
      setStudioPhoto(_studioPhoto);
    };
    init();
  }, [locationId, mediaId]);

  return (
    <img
      style={{ width: '100%', aspectRatio: '1/1', objectFit: 'cover' }}
      src={studioPhoto?.url}
      alt={studioPhoto?.name}
    />
  );
};

export default SocialPostImage;
